import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { sort, length, contains as contains_1, forAll, isEmpty, cons, ofArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_HttpRequestHeaders, Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { News_AdminNews, News_BundeslandInfo_$reflection, Admin_AdminInfos$1_$reflection, News_AdminNews_$reflection, News_AdminNewsListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { comparePrimitives, defaultOf, stringHash, numberHash, equals, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { bool_type, list_type, int32_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { errorCmd, Loaded, request, postEmpty } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { contains, empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { NewsModel, Filter, NewsListModel, NewsListModel_Init, Model, NewsModel_Init, Msg } from "./Types.fs.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { tryInt } from "../../../../Bfs.Web.Portale/Helpers.fs.js";
import { dateUpdate, update } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { Markdown_ToHtml_1BFEAEDB } from "../../../fable_modules/Fable.Formatting.Markdown.1.0.1/Markdown.fs.js";
import { today } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { List_distinct, List_except } from "../../../fable_modules/fable-library-js.4.19.0/Seq2.js";
import { value as value_8 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";

export function Http_getNewsList(page, filter) {
    const response = fetch((filter.tag === 1) ? toText(printf("/api/admin/news/pflege?page=%i"))(page) : ((filter.tag === 2) ? toText(printf("/api/admin/news/therapie?page=%i"))(page) : ((filter.tag === 3) ? toText(printf("/api/admin/news/bfsplus?page=%i"))(page) : ((filter.tag === 4) ? toText(printf("/api/admin/news/jugendhilfe?page=%i"))(page) : ((filter.tag === 5) ? toText(printf("/api/admin/news/kunde/%i/?page=%i"))(filter.fields[0])(page) : toText(printf("/api/admin/news?page=%i"))(page))))), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Paginated$1_$reflection(News_AdminNewsListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getNews(id) {
    let arg;
    const response = fetch((arg = encodeURIComponent(id), toText(printf("/api/admin/news/%s"))(arg)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Admin_AdminInfos$1_$reflection(News_AdminNews_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getAllKundennummern() {
    const response = fetch("/api/admin/kundennummern", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(int32_type), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getAllBundeslaender() {
    const response = fetch("/api/admin/bundeslaender", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(News_BundeslandInfo_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postNews(id, news) {
    let arg;
    return sendJson((arg = encodeURIComponent(id), toText(printf("/api/admin/news/%s"))(arg)), toString(0, Auto_generateBoxedEncoder_437914C6(News_AdminNews_$reflection(), undefined, undefined, undefined)(news)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function Http_postActivate(id) {
    let arg;
    return postEmpty((arg = encodeURIComponent(id), toText(printf("/api/admin/news/%s/active"))(arg)));
}

export function Http_postDeactivate(id) {
    let arg;
    return postEmpty((arg = encodeURIComponent(id), toText(printf("/api/admin/news/%s/inactive"))(arg)));
}

export function Http_postImage(id, file) {
    let url;
    const arg = encodeURIComponent(id);
    url = toText(printf("/api/admin/news/%s/image"))(arg);
    const formData = new FormData();
    formData.append("file", file);
    const response = fetch(url, keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [((Item) => (new Types_HttpRequestHeaders(11, [Item])))("multipart/form-data")]), new Types_RequestProperties(2, [formData])])), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(bool_type, new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_imageUrl(updateTrigger, id) {
    const arg = encodeURIComponent(id);
    return toText(printf("/api/admin/news/%s/image?v=%i"))(arg)(updateTrigger);
}

function State_loadMissingDataCmds(kdnr, bundeslaender) {
    return toList(delay(() => append_1(equals(kdnr, empty()) ? singleton_1(singleton((dispatch) => {
        dispatch(new Msg(11, []));
    })) : empty_1(), delay(() => (equals(bundeslaender, empty()) ? singleton_1(singleton((dispatch_1) => {
        dispatch_1(new Msg(13, []));
    })) : empty_1())))));
}

export function State_init(page, user, lastModel) {
    let m_4, m_5, m_1, m, m_3, m_2;
    switch (page.tag) {
        case 1: {
            const id = page.fields[0];
            const patternInput = (lastModel != null) ? ((lastModel.tag === 0) ? ((m_4 = lastModel.fields[0], [m_4.PageNumber, m_4.AllKundennummern, m_4.AllBundeslaender])) : [1, empty(), empty()]) : [1, empty(), empty()];
            const kdnr_1 = patternInput[1];
            const bundeslaender_1 = patternInput[2];
            return [new Model(1, [NewsModel_Init(id, patternInput[0], kdnr_1, bundeslaender_1)]), Cmd_batch(cons(singleton((dispatch_1) => {
                dispatch_1(new Msg(9, [id]));
            }), State_loadMissingDataCmds(kdnr_1, bundeslaender_1)))];
        }
        case 2: {
            const patternInput_1 = (lastModel != null) ? ((lastModel.tag === 0) ? ((m_5 = lastModel.fields[0], [m_5.PageNumber, m_5.AllKundennummern, m_5.AllBundeslaender])) : [1, empty(), empty()]) : [1, empty(), empty()];
            const kdnr_2 = patternInput_1[1];
            const bundeslaender_2 = patternInput_1[2];
            return [new Model(1, [NewsModel_Init(undefined, patternInput_1[0], kdnr_2, bundeslaender_2)]), Cmd_batch(cons(singleton((dispatch_2) => {
                dispatch_2(new Msg(8, []));
            }), State_loadMissingDataCmds(kdnr_2, bundeslaender_2)))];
        }
        default: {
            const pagenumber = page.fields[0] | 0;
            const kdnr = (lastModel == null) ? empty() : ((lastModel.tag === 1) ? ((m_1 = lastModel.fields[0], m_1.AllKundennummern)) : ((m = lastModel.fields[0], m.AllKundennummern)));
            const bundeslaender = (lastModel == null) ? empty() : ((lastModel.tag === 1) ? ((m_3 = lastModel.fields[0], m_3.AllBundeslaender)) : ((m_2 = lastModel.fields[0], m_2.AllBundeslaender)));
            return [new Model(0, [NewsListModel_Init(pagenumber, kdnr, bundeslaender)]), Cmd_batch(cons(singleton((dispatch) => {
                dispatch(new Msg(0, [pagenumber]));
            }), State_loadMissingDataCmds(kdnr, bundeslaender)))];
        }
    }
}

export function State_update(msg, model) {
    let kdnr_1, Titel, Text$, TextAsHtml, matchValue_4;
    let matchResult, model_1, pagenumber, model_2, x, filter_1, model_3, model_4, id, id_2, model_5, id_4, jobmodel, model_7, news, exn, model_8, model_9, lst, model_10, lst_1, model_11, exn_2, model_12, model_13, lst_2, model_14, lst_3, model_15, exn_4, model_16, id_6, model_17, model_18, model_19, value_1, model_20, value_2, date, model_21, state, model_22, value_3, model_23, value_4, model_24, file_1, model_25, hasImage, model_26, exn_6, model_27, model_28, value_5, model_29, value_6, model_30, kdnr_8, model_31, model_32, model_33, e, model_34, id_12, model_35, e_1, model_36;
    switch (msg.tag) {
        case 1: {
            if (model.tag === 0) {
                matchResult = 1;
                model_2 = model.fields[0];
                x = msg.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 2: {
            if (model.tag === 0) {
                matchResult = 2;
                filter_1 = msg.fields[0];
                model_3 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 4: {
            if (model.tag === 0) {
                matchResult = 3;
                model_4 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 5: {
            matchResult = 4;
            id = msg.fields[0];
            break;
        }
        case 6: {
            matchResult = 5;
            id_2 = msg.fields[0];
            break;
        }
        case 7: {
            if (model.tag === 0) {
                matchResult = 6;
                model_5 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 9: {
            if (model.tag === 1) {
                matchResult = 7;
                id_4 = msg.fields[0];
                jobmodel = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 10: {
            if (msg.fields[0].tag === 1) {
                matchResult = 9;
                exn = msg.fields[0].fields[0];
            }
            else if (model.tag === 1) {
                matchResult = 8;
                model_7 = model.fields[0];
                news = msg.fields[0].fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 8: {
            if (model.tag === 1) {
                matchResult = 10;
                model_8 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 11: {
            matchResult = 11;
            model_9 = model;
            break;
        }
        case 12: {
            if (msg.fields[0].tag === 1) {
                matchResult = 14;
                exn_2 = msg.fields[0].fields[0];
                model_12 = model;
            }
            else if (model.tag === 0) {
                matchResult = 13;
                lst_1 = msg.fields[0].fields[0];
                model_11 = model.fields[0];
            }
            else {
                matchResult = 12;
                lst = msg.fields[0].fields[0];
                model_10 = model.fields[0];
            }
            break;
        }
        case 13: {
            matchResult = 15;
            model_13 = model;
            break;
        }
        case 14: {
            if (msg.fields[0].tag === 1) {
                matchResult = 18;
                exn_4 = msg.fields[0].fields[0];
                model_16 = model;
            }
            else if (model.tag === 0) {
                matchResult = 17;
                lst_3 = msg.fields[0].fields[0];
                model_15 = model.fields[0];
            }
            else {
                matchResult = 16;
                lst_2 = msg.fields[0].fields[0];
                model_14 = model.fields[0];
            }
            break;
        }
        case 15: {
            if (model.tag === 1) {
                matchResult = 19;
                id_6 = msg.fields[0];
                model_17 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 16: {
            if (model.tag === 1) {
                matchResult = 20;
                model_18 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 17: {
            if (model.tag === 1) {
                matchResult = 21;
                model_19 = model.fields[0];
                value_1 = msg.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 18: {
            if (model.tag === 1) {
                matchResult = 22;
                model_20 = model.fields[0];
                value_2 = msg.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 19: {
            if (model.tag === 1) {
                matchResult = 23;
                date = msg.fields[1];
                model_21 = model.fields[0];
                state = msg.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 20: {
            if (model.tag === 1) {
                matchResult = 24;
                model_22 = model.fields[0];
                value_3 = msg.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 21: {
            if (model.tag === 1) {
                matchResult = 25;
                model_23 = model.fields[0];
                value_4 = msg.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 25: {
            if (model.tag === 1) {
                matchResult = 26;
                model_24 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 26: {
            if (model.tag === 1) {
                matchResult = 27;
                file_1 = msg.fields[0];
                model_25 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 27: {
            if (msg.fields[0].tag === 1) {
                matchResult = 29;
                exn_6 = msg.fields[0].fields[0];
                model_27 = model;
            }
            else if (model.tag === 1) {
                matchResult = 28;
                hasImage = msg.fields[0].fields[0];
                model_26 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 3: {
            if (model.tag === 0) {
                matchResult = 30;
                model_28 = model.fields[0];
                value_5 = msg.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 22: {
            if (model.tag === 1) {
                matchResult = 31;
                model_29 = model.fields[0];
                value_6 = msg.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 23: {
            if (model.tag === 1) {
                matchResult = 32;
                model_30 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 24: {
            if (model.tag === 1) {
                matchResult = 33;
                kdnr_8 = msg.fields[0];
                model_31 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 28: {
            if (model.tag === 1) {
                matchResult = 34;
                model_32 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 29: {
            if (msg.fields[0].tag === 1) {
                if (model.tag === 1) {
                    matchResult = 36;
                    e = msg.fields[0].fields[0];
                    model_34 = model.fields[0];
                }
                else {
                    matchResult = 40;
                }
            }
            else if (model.tag === 1) {
                matchResult = 35;
                model_33 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 30: {
            if (msg.fields[0].tag === 1) {
                if (model.tag === 1) {
                    matchResult = 38;
                    e_1 = msg.fields[0].fields[0];
                    model_36 = model.fields[0];
                }
                else {
                    matchResult = 40;
                }
            }
            else if (model.tag === 1) {
                matchResult = 37;
                id_12 = msg.fields[0].fields[0];
                model_35 = model.fields[0];
            }
            else {
                matchResult = 40;
            }
            break;
        }
        case 31: {
            matchResult = 39;
            break;
        }
        default:
            if (model.tag === 0) {
                matchResult = 0;
                model_1 = model.fields[0];
                pagenumber = msg.fields[0];
            }
            else {
                matchResult = 40;
            }
    }
    switch (matchResult) {
        case 0:
            return [new Model(0, [new NewsListModel(model_1.PageNumber, model_1.Filter, new Remote$1(1, []), model_1.AllKundennummern, model_1.KundennummernFilterText, model_1.KundennummernFilterEnabeld, model_1.AllBundeslaender)]), request((tupledArg) => Http_getNewsList(tupledArg[0], tupledArg[1]), [pagenumber, model_1.Filter], (Item) => (new Msg(1, [Item])))];
        case 1:
            return [new Model(0, [new NewsListModel(model_2.PageNumber, model_2.Filter, Loaded(x), model_2.AllKundennummern, model_2.KundennummernFilterText, model_2.KundennummernFilterEnabeld, model_2.AllBundeslaender)]), Cmd_none()];
        case 2:
            return [new Model(0, [new NewsListModel(model_3.PageNumber, filter_1, model_3.News, model_3.AllKundennummern, model_3.KundennummernFilterText, model_3.KundennummernFilterEnabeld, model_3.AllBundeslaender)]), singleton((dispatch) => {
                dispatch(new Msg(0, [1]));
            })];
        case 3: {
            const kdnr = tryInt(model_4.KundennummernFilterText);
            return [new Model(0, [model_4]), (kdnr == null) ? Cmd_none() : ((kdnr_1 = (kdnr | 0), contains(kdnr_1, model_4.AllKundennummern, {
                Equals: (x_1, y) => (x_1 === y),
                GetHashCode: numberHash,
            }) ? singleton((dispatch_1) => {
                dispatch_1(new Msg(2, [new Filter(5, [kdnr_1])]));
            }) : Cmd_none()))];
        }
        case 4:
            return [model, request(Http_postActivate, id, (Item_5) => (new Msg(7, [Item_5])))];
        case 5:
            return [model, request(Http_postDeactivate, id_2, (Item_6) => (new Msg(7, [Item_6])))];
        case 6:
            return [new Model(0, [model_5]), singleton((dispatch_2) => {
                dispatch_2(new Msg(0, [model_5.PageNumber]));
            })];
        case 7:
            return [new Model(1, [new NewsModel(id_4, jobmodel.BackToPage, jobmodel.Titel, jobmodel.Text, jobmodel.GueltigAb, jobmodel.Aktiv, jobmodel.KundenTyp, jobmodel.Kundennummern, jobmodel.HasImage, jobmodel.ImageUpdateTrigger, jobmodel.AllKundennummern, jobmodel.KundennummernAddText, jobmodel.KundennummernAddEnabeld, jobmodel.Bundeslaender, jobmodel.AllBundeslaender, jobmodel.IsDirty, jobmodel.Sending, jobmodel.TextAsHtml)]), request(Http_getNews, id_4, (Item_8) => (new Msg(10, [Item_8])))];
        case 8:
            return [new Model(1, [(Titel = update(model_7.Titel, news.Item.Titel), (Text$ = update(model_7.Text, news.Item.Text), (TextAsHtml = Markdown_ToHtml_1BFEAEDB(news.Item.Text), new NewsModel(model_7.Id, model_7.BackToPage, Titel, Text$, dateUpdate(model_7.GueltigAb, model_7.GueltigAb.DatePickerState, news.Item.GueltigAb, news.Item.GueltigAb), news.Item.Aktiv, news.Item.KundenTyp, news.Item.Kundennummern, news.HasImage, model_7.ImageUpdateTrigger, model_7.AllKundennummern, model_7.KundennummernAddText, model_7.KundennummernAddEnabeld, news.Item.Bundeslaender, model_7.AllBundeslaender, false, model_7.Sending, TextAsHtml))))]), Cmd_none()];
        case 9:
            return [model, errorCmd((Item_10) => (new Msg(31, [Item_10])), "Laden", exn)];
        case 10:
            return [new Model(1, [new NewsModel(model_8.Id, model_8.BackToPage, update(model_8.Titel, "Neue news"), model_8.Text, dateUpdate(model_8.GueltigAb, model_8.GueltigAb.DatePickerState, today(), today()), true, model_8.KundenTyp, model_8.Kundennummern, model_8.HasImage, model_8.ImageUpdateTrigger, model_8.AllKundennummern, model_8.KundennummernAddText, model_8.KundennummernAddEnabeld, model_8.Bundeslaender, model_8.AllBundeslaender, true, model_8.Sending, model_8.TextAsHtml)]), Cmd_none()];
        case 11:
            return [model_9, request(Http_getAllKundennummern, undefined, (Item_12) => (new Msg(12, [Item_12])))];
        case 12:
            return [new Model(1, [new NewsModel(model_10.Id, model_10.BackToPage, model_10.Titel, model_10.Text, model_10.GueltigAb, model_10.Aktiv, model_10.KundenTyp, model_10.Kundennummern, model_10.HasImage, model_10.ImageUpdateTrigger, lst, model_10.KundennummernAddText, model_10.KundennummernAddEnabeld, model_10.Bundeslaender, model_10.AllBundeslaender, model_10.IsDirty, model_10.Sending, model_10.TextAsHtml)]), Cmd_none()];
        case 13:
            return [new Model(0, [new NewsListModel(model_11.PageNumber, model_11.Filter, model_11.News, lst_1, model_11.KundennummernFilterText, model_11.KundennummernFilterEnabeld, model_11.AllBundeslaender)]), Cmd_none()];
        case 14:
            return [model_12, errorCmd((Item_15) => (new Msg(31, [Item_15])), "Laden aller Kundennummern", exn_2)];
        case 15:
            return [model_13, request(Http_getAllBundeslaender, undefined, (Item_16) => (new Msg(14, [Item_16])))];
        case 16:
            return [new Model(1, [new NewsModel(model_14.Id, model_14.BackToPage, model_14.Titel, model_14.Text, model_14.GueltigAb, model_14.Aktiv, model_14.KundenTyp, model_14.Kundennummern, model_14.HasImage, model_14.ImageUpdateTrigger, model_14.AllKundennummern, model_14.KundennummernAddText, model_14.KundennummernAddEnabeld, model_14.Bundeslaender, lst_2, model_14.IsDirty, model_14.Sending, model_14.TextAsHtml)]), Cmd_none()];
        case 17:
            return [new Model(0, [new NewsListModel(model_15.PageNumber, model_15.Filter, model_15.News, model_15.AllKundennummern, model_15.KundennummernFilterText, model_15.KundennummernFilterEnabeld, lst_3)]), Cmd_none()];
        case 18:
            return [model_16, errorCmd((Item_19) => (new Msg(31, [Item_19])), "Laden aller Bundesländer", exn_4)];
        case 19: {
            const bundeslaender = (isEmpty(model_17.Bundeslaender) ? true : (!isEmpty(model_17.AllBundeslaender) && forAll((b) => contains_1(b.Id, model_17.Bundeslaender, {
                Equals: (x_2, y_1) => (x_2 === y_1),
                GetHashCode: stringHash,
            }), model_17.AllBundeslaender))) ? singleton(id_6) : (contains_1(id_6, model_17.Bundeslaender, {
                Equals: (x_3, y_2) => (x_3 === y_2),
                GetHashCode: stringHash,
            }) ? List_except([id_6], model_17.Bundeslaender, {
                Equals: (x_4, y_3) => (x_4 === y_3),
                GetHashCode: stringHash,
            }) : append(singleton(id_6), model_17.Bundeslaender));
            return [new Model(1, [new NewsModel(model_17.Id, model_17.BackToPage, model_17.Titel, model_17.Text, model_17.GueltigAb, model_17.Aktiv, model_17.KundenTyp, model_17.Kundennummern, model_17.HasImage, model_17.ImageUpdateTrigger, model_17.AllKundennummern, model_17.KundennummernAddText, model_17.KundennummernAddEnabeld, (!isEmpty(bundeslaender) && (length(bundeslaender) === length(model_17.AllBundeslaender))) ? empty() : bundeslaender, model_17.AllBundeslaender, true, model_17.Sending, model_17.TextAsHtml)]), Cmd_none()];
        }
        case 20:
            return [new Model(1, [new NewsModel(model_18.Id, model_18.BackToPage, model_18.Titel, model_18.Text, model_18.GueltigAb, model_18.Aktiv, model_18.KundenTyp, model_18.Kundennummern, model_18.HasImage, model_18.ImageUpdateTrigger, model_18.AllKundennummern, model_18.KundennummernAddText, model_18.KundennummernAddEnabeld, empty(), model_18.AllBundeslaender, true, model_18.Sending, model_18.TextAsHtml)]), Cmd_none()];
        case 21:
            return [new Model(1, [new NewsModel(model_19.Id, model_19.BackToPage, update(model_19.Titel, value_1), model_19.Text, model_19.GueltigAb, model_19.Aktiv, model_19.KundenTyp, model_19.Kundennummern, model_19.HasImage, model_19.ImageUpdateTrigger, model_19.AllKundennummern, model_19.KundennummernAddText, model_19.KundennummernAddEnabeld, model_19.Bundeslaender, model_19.AllBundeslaender, true, model_19.Sending, model_19.TextAsHtml)]), Cmd_none()];
        case 22:
            return [new Model(1, [new NewsModel(model_20.Id, model_20.BackToPage, model_20.Titel, update(model_20.Text, value_2), model_20.GueltigAb, model_20.Aktiv, model_20.KundenTyp, model_20.Kundennummern, model_20.HasImage, model_20.ImageUpdateTrigger, model_20.AllKundennummern, model_20.KundennummernAddText, model_20.KundennummernAddEnabeld, model_20.Bundeslaender, model_20.AllBundeslaender, true, model_20.Sending, Markdown_ToHtml_1BFEAEDB(value_2))]), Cmd_none()];
        case 23:
            return [new Model(1, [new NewsModel(model_21.Id, model_21.BackToPage, model_21.Titel, model_21.Text, dateUpdate(model_21.GueltigAb, state, date, undefined), model_21.Aktiv, model_21.KundenTyp, model_21.Kundennummern, model_21.HasImage, model_21.ImageUpdateTrigger, model_21.AllKundennummern, model_21.KundennummernAddText, model_21.KundennummernAddEnabeld, model_21.Bundeslaender, model_21.AllBundeslaender, true, model_21.Sending, model_21.TextAsHtml)]), Cmd_none()];
        case 24:
            return [new Model(1, [new NewsModel(model_22.Id, model_22.BackToPage, model_22.Titel, model_22.Text, model_22.GueltigAb, value_3, model_22.KundenTyp, model_22.Kundennummern, model_22.HasImage, model_22.ImageUpdateTrigger, model_22.AllKundennummern, model_22.KundennummernAddText, model_22.KundennummernAddEnabeld, model_22.Bundeslaender, model_22.AllBundeslaender, true, model_22.Sending, model_22.TextAsHtml)]), Cmd_none()];
        case 25:
            return [new Model(1, [new NewsModel(model_23.Id, model_23.BackToPage, model_23.Titel, model_23.Text, model_23.GueltigAb, model_23.Aktiv, value_4, model_23.Kundennummern, model_23.HasImage, model_23.ImageUpdateTrigger, model_23.AllKundennummern, model_23.KundennummernAddText, model_23.KundennummernAddEnabeld, model_23.Bundeslaender, model_23.AllBundeslaender, true, model_23.Sending, model_23.TextAsHtml)]), Cmd_none()];
        case 26:
            return [new Model(1, [model_24]), request((tupledArg_1) => Http_postImage(tupledArg_1[0], tupledArg_1[1]), [value_8(model_24.Id), defaultOf()], (Item_28) => (new Msg(27, [Item_28])))];
        case 27:
            return [new Model(1, [model_25]), request((tupledArg_2) => Http_postImage(tupledArg_2[0], tupledArg_2[1]), [value_8(model_25.Id), file_1], (Item_30) => (new Msg(27, [Item_30])))];
        case 28:
            return [new Model(1, [new NewsModel(model_26.Id, model_26.BackToPage, model_26.Titel, model_26.Text, model_26.GueltigAb, model_26.Aktiv, model_26.KundenTyp, model_26.Kundennummern, hasImage, model_26.ImageUpdateTrigger + 1, model_26.AllKundennummern, model_26.KundennummernAddText, model_26.KundennummernAddEnabeld, model_26.Bundeslaender, model_26.AllBundeslaender, model_26.IsDirty, model_26.Sending, model_26.TextAsHtml)]), Cmd_none()];
        case 29:
            return [model_27, errorCmd((Item_32) => (new Msg(31, [Item_32])), "Speichern des Bilds", exn_6)];
        case 30: {
            const kdnr_2 = tryInt(value_5);
            return [new Model(0, [new NewsListModel(model_28.PageNumber, model_28.Filter, model_28.News, model_28.AllKundennummern, value_5, (kdnr_2 == null) ? false : contains(kdnr_2, model_28.AllKundennummern, {
                Equals: (x_5, y_4) => (x_5 === y_4),
                GetHashCode: numberHash,
            }), model_28.AllBundeslaender)]), Cmd_none()];
        }
        case 31: {
            const kdnr_4 = tryInt(value_6);
            return [new Model(1, [new NewsModel(model_29.Id, model_29.BackToPage, model_29.Titel, model_29.Text, model_29.GueltigAb, model_29.Aktiv, model_29.KundenTyp, model_29.Kundennummern, model_29.HasImage, model_29.ImageUpdateTrigger, model_29.AllKundennummern, value_6, (kdnr_4 == null) ? false : contains(kdnr_4, model_29.AllKundennummern, {
                Equals: (x_6, y_5) => (x_6 === y_5),
                GetHashCode: numberHash,
            }), model_29.Bundeslaender, model_29.AllBundeslaender, model_29.IsDirty, model_29.Sending, model_29.TextAsHtml)]), Cmd_none()];
        }
        case 32: {
            const kdnr_6 = tryInt(model_30.KundennummernAddText);
            return [new Model(1, [model_30.KundennummernAddEnabeld ? ((kdnr_6 != null) ? (new NewsModel(model_30.Id, model_30.BackToPage, model_30.Titel, model_30.Text, model_30.GueltigAb, model_30.Aktiv, model_30.KundenTyp, sort(List_distinct(append(singleton(kdnr_6), model_30.Kundennummern), {
                Equals: (x_7, y_6) => (x_7 === y_6),
                GetHashCode: numberHash,
            }), {
                Compare: comparePrimitives,
            }), model_30.HasImage, model_30.ImageUpdateTrigger, model_30.AllKundennummern, "", false, model_30.Bundeslaender, model_30.AllBundeslaender, true, model_30.Sending, model_30.TextAsHtml)) : model_30) : model_30]), Cmd_none()];
        }
        case 33:
            return [new Model(1, [new NewsModel(model_31.Id, model_31.BackToPage, model_31.Titel, model_31.Text, model_31.GueltigAb, model_31.Aktiv, model_31.KundenTyp, sort(List_except([kdnr_8], model_31.Kundennummern, {
                Equals: (x_9, y_8) => (x_9 === y_8),
                GetHashCode: numberHash,
            }), {
                Compare: comparePrimitives,
            }), model_31.HasImage, model_31.ImageUpdateTrigger, model_31.AllKundennummern, model_31.KundennummernAddText, model_31.KundennummernAddEnabeld, model_31.Bundeslaender, model_31.AllBundeslaender, true, model_31.Sending, model_31.TextAsHtml)]), Cmd_none()];
        case 34: {
            const news_1 = new News_AdminNews(model_32.Titel.Value, model_32.Text.Value, value_8(model_32.GueltigAb.Value), model_32.Aktiv, model_32.KundenTyp, model_32.Kundennummern, model_32.Bundeslaender);
            return [new Model(1, [new NewsModel(model_32.Id, model_32.BackToPage, model_32.Titel, model_32.Text, model_32.GueltigAb, model_32.Aktiv, model_32.KundenTyp, model_32.Kundennummern, model_32.HasImage, model_32.ImageUpdateTrigger, model_32.AllKundennummern, model_32.KundennummernAddText, model_32.KundennummernAddEnabeld, model_32.Bundeslaender, model_32.AllBundeslaender, model_32.IsDirty, true, model_32.TextAsHtml)]), (matchValue_4 = model_32.Id, (matchValue_4 == null) ? request((news_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (sendJson("/api/admin/news", toString(0, Auto_generateBoxedEncoder_437914C6(News_AdminNews_$reflection(), undefined, undefined, undefined)(news_3)), singleton(new Types_RequestProperties(4, ["include"])), "PUT").then((_arg) => (_arg.json().then((_arg_1) => (Promise.resolve(_arg_1)))))))), news_1, (Item_38) => (new Msg(30, [Item_38]))) : request((tupledArg_3) => Http_postNews(tupledArg_3[0], tupledArg_3[1]), [matchValue_4, news_1], (Item_37) => (new Msg(29, [Item_37]))))];
        }
        case 35:
            return [new Model(1, [new NewsModel(model_33.Id, model_33.BackToPage, model_33.Titel, model_33.Text, model_33.GueltigAb, model_33.Aktiv, model_33.KundenTyp, model_33.Kundennummern, model_33.HasImage, model_33.ImageUpdateTrigger, model_33.AllKundennummern, model_33.KundennummernAddText, model_33.KundennummernAddEnabeld, model_33.Bundeslaender, model_33.AllBundeslaender, false, false, model_33.TextAsHtml)]), Cmd_none()];
        case 36:
            return [new Model(1, [new NewsModel(model_34.Id, model_34.BackToPage, model_34.Titel, model_34.Text, model_34.GueltigAb, model_34.Aktiv, model_34.KundenTyp, model_34.Kundennummern, model_34.HasImage, model_34.ImageUpdateTrigger, model_34.AllKundennummern, model_34.KundennummernAddText, model_34.KundennummernAddEnabeld, model_34.Bundeslaender, model_34.AllBundeslaender, model_34.IsDirty, false, model_34.TextAsHtml)]), errorCmd((Item_42) => (new Msg(31, [Item_42])), "Speichern", e)];
        case 37:
            return [new Model(1, [new NewsModel(id_12, model_35.BackToPage, model_35.Titel, model_35.Text, model_35.GueltigAb, model_35.Aktiv, model_35.KundenTyp, model_35.Kundennummern, model_35.HasImage, model_35.ImageUpdateTrigger, model_35.AllKundennummern, model_35.KundennummernAddText, model_35.KundennummernAddEnabeld, model_35.Bundeslaender, model_35.AllBundeslaender, false, false, model_35.TextAsHtml)]), Cmd_none()];
        case 38:
            return [new Model(1, [new NewsModel(model_36.Id, model_36.BackToPage, model_36.Titel, model_36.Text, model_36.GueltigAb, model_36.Aktiv, model_36.KundenTyp, model_36.Kundennummern, model_36.HasImage, model_36.ImageUpdateTrigger, model_36.AllKundennummern, model_36.KundennummernAddText, model_36.KundennummernAddEnabeld, model_36.Bundeslaender, model_36.AllBundeslaender, model_36.IsDirty, false, model_36.TextAsHtml)]), errorCmd((Item_45) => (new Msg(31, [Item_45])), "Speichern", e_1)];
        case 39:
            return [model, Cmd_none()];
        default: {
            return [model, Cmd_none()];
        }
    }
}

//# sourceMappingURL=State.fs.js.map
